export default __webpack_public_path__ + "static/media/resetfinal.7646c938.png";